var _circle, _path, _path2, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 74,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9062 44.8438V38.5938C96.9063 36.3863 96.0315 34.2687 94.4735 32.7048C92.9155 31.141 90.8012 30.2583 88.5938 30.25H38.5938C36.3834 30.2582 34.2659 31.1399 32.7029 32.7029C31.1399 34.2659 30.2582 36.3834 30.25 38.5938V88.5938C30.2583 90.8012 31.141 92.9155 32.7048 94.4735C34.2687 96.0315 36.3863 96.9063 38.5938 96.9062H44.8438V57.3438C44.8438 54.0285 46.1607 50.8491 48.5049 48.5049C50.8491 46.1607 54.0285 44.8438 57.3438 44.8438H96.9062Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 51.0938H57.3438C55.6861 51.0938 54.0964 51.7522 52.9243 52.9243C51.7522 54.0964 51.0938 55.6861 51.0938 57.3438V111.5C51.0938 113.158 51.7522 114.747 52.9243 115.919C54.0964 117.092 55.6861 117.75 57.3438 117.75H111.5C113.158 117.75 114.747 117.092 115.919 115.919C117.092 114.747 117.75 113.158 117.75 111.5V57.3438C117.75 55.6861 117.092 54.0964 115.919 52.9243C114.747 51.7522 113.158 51.0938 111.5 51.0938ZM101.094 87.5312H87.5312V101.094C87.5312 101.923 87.202 102.717 86.616 103.303C86.0299 103.89 85.2351 104.219 84.4062 104.219C83.5774 104.219 82.7826 103.89 82.1965 103.303C81.6105 102.717 81.2812 101.923 81.2812 101.094V87.5312H67.75C66.9212 87.5312 66.1263 87.202 65.5403 86.616C64.9542 86.0299 64.625 85.2351 64.625 84.4062C64.6278 83.9406 64.7345 83.4815 64.9375 83.0625L66.4062 81.5938C66.8253 81.3908 67.2844 81.284 67.75 81.2812H81.2812V67.75C81.284 67.2844 81.3908 66.8253 81.5938 66.4062L83.0625 64.9375C83.4815 64.7345 83.9406 64.6278 84.4062 64.625C85.2351 64.625 86.0299 64.9542 86.616 65.5403C87.202 66.1263 87.5312 66.9212 87.5312 67.75V81.2812H101.094C101.923 81.2812 102.717 81.6105 103.303 82.1965C103.89 82.7826 104.219 83.5774 104.219 84.4062C104.219 85.2351 103.89 86.0299 103.303 86.616C102.717 87.202 101.923 87.5312 101.094 87.5312Z",
    fill: "#C9C9C9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 6.5,
    r: 6.5,
    fill: "#CCCCCC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 64.5,
    r: 6,
    stroke: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 99.5,
    r: 6,
    fill: "#CCCCCC",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d1f92989430b31ed31bda82ccccb8bee.svg";
export { ForwardRef as ReactComponent };